import { ArrowUpLeft } from "lucide-react";
import { useTools } from "@/content/ContentProvider";
import { pickLang, useLanguage } from "@/i18n/LanguageContext";

const LABELS = {
  ar: {
    eyebrow: "موصى بها",
    title: "أدوات ذات صلة",
    desc: "أدوات مجانية من دليل SAS ترتبط مباشرة بموضوع هذه المقالة.",
    free: "مجاني",
    open: "فتح الأداة",
  },
  en: {
    eyebrow: "Recommended",
    title: "Related tools",
    desc: "Free tools from the SAS directory that relate directly to this article's topic.",
    free: "Free",
    open: "Open tool",
  },
};

export default function RelatedTools({ toolSlugs = [] }) {
  const { lang } = useLanguage();
  const { getToolBySlug, primaryCategoryOf } = useTools();
  const l = LABELS[lang];
  const tools = toolSlugs.map(getToolBySlug).filter(Boolean);
  if (tools.length === 0) return null;

  return (
    <section
      className="mt-16 pt-10 border-t border-[color:var(--sas-line)]"
      data-testid="related-tools"
      aria-labelledby="related-tools-title"
    >
      <div className="sas-eyebrow mb-2">{l.eyebrow}</div>
      <h2 id="related-tools-title" className="sas-h2">{l.title}</h2>
      <p className="sas-body mt-2 text-[15px] max-w-xl">{l.desc}</p>

      <div className="sas-grid-2 mt-8">
        {tools.map((t) => {
          const cat = primaryCategoryOf(t);
          return (
            <article key={t.slug} className="sas-card" data-testid={`related-tool-${t.slug}`}>
              <div className="flex items-start justify-between gap-3 mb-3">
                <span className="sas-chip">{pickLang(cat?.label, lang)}</span>
                <span className="text-xs text-[color:var(--sas-ink-2)]">{l.free}</span>
              </div>
              <h3 className="sas-h3">{t.name}</h3>
              <p className="sas-body mt-2 text-[15px]">{pickLang(t.desc, lang)}</p>
              <div className="mt-4 text-sm text-[color:var(--sas-ink-2)]">{pickLang(t.audience, lang)}</div>
              <a
                href={t.url}
                target="_blank"
                rel="noreferrer noopener"
                className="sas-btn sas-btn-ghost mt-5 self-start"
              >
                {l.open} <ArrowUpLeft size={16} />
              </a>
            </article>
          );
        })}
      </div>
    </section>
  );
}
